interface TaskStatusPanelProps {
  taskId: string;
  label: string;
  phase: 'thinking' | 'done' | 'error';
  text: string;
}

export default function TaskStatusPanel({ label, phase, text }: TaskStatusPanelProps) {
  const truncatedText = text.length > 80 ? text.slice(0, 80) + '...' : text;

  return (
    <div className="flex items-center gap-3 rounded-2xl border border-border bg-secondary px-4 py-2 text-sm shadow-sm mb-3 max-w-full overflow-hidden">
      {phase === 'thinking' && (
        <div className="h-4 w-4 flex-shrink-0 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      )}
      {phase === 'done' && (
        <svg className="h-4 w-4 flex-shrink-0 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      )}
      {phase === 'error' && (
        <svg className="h-4 w-4 flex-shrink-0 text-destructive-foreground" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      )}
      
      <div className="flex items-center gap-2 min-w-0 truncate">
        <span className={`font-medium whitespace-nowrap ${phase === 'error' ? 'text-destructive-foreground' : 'text-card-foreground'}`}>
          {label}
        </span>
        {phase === 'thinking' && truncatedText && (
          <>
            <span className="text-muted-foreground whitespace-nowrap">—</span>
            <span className="text-muted-foreground truncate">{truncatedText}</span>
          </>
        )}
        {phase === 'error' && text && (
          <>
            <span className="text-destructive-foreground whitespace-nowrap">—</span>
            <span className="text-destructive-foreground truncate">{text}</span>
          </>
        )}
      </div>
    </div>
  );
}
